import { render, staticRenderFns } from "./Reported.vue?vue&type=template&id=7509ecf2"
import script from "./Reported.vue?vue&type=script&lang=js"
export * from "./Reported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports